import React from 'react';
import './Home.css';

const Home = () => {
  return (
    <div className="wrapper">
      <header data-fls-header="" data-fls-header-scroll="" className="header">
        <div className="header__container header__container--full">
          <div className="header__body">
            <a href="/" className="header__logo">
              <img src="/assets/img/logo.svg" alt="Logo" />
            </a>
            <div className="header__actions">
              <a href="/login" data-fls-button="" className="header__button button button--fw button--border">Вход</a>
              <a href="/signup" data-fls-button="" className="header__button button button--fw">Регистрация</a>
            </div>
          </div>
        </div>
      </header>
      <main className="page page--landing">
        <section className="hero">
          <div className="hero__container hero__container--full">
            <div className="hero__body">
              <h1 className="hero__title">
                Инвестиции в счета
                <br />
                профессиональных
                <br />
                управляющих
              </h1>
              <div className="hero__text">
                <p>
                  Уровень доходности
                  <span> 60% годовых </span>
                  привлекает инвесторов,
                  <br />
                  стремящихся к приумножению средств.
                </p>
              </div>
              <a href="/signup" data-fls-button="" className="hero__button button">Инвестировать</a>
            </div>
          </div>
        </section>
        <section className="advant">
          <div className="advant__container advant__container--full">
            <div className="advant__body">
              <h2 className="advant__title">5 преимуществ инвестирования в ПАММ-счета</h2>
              <div className="advant__items">
                <div data-fls-shadow="" className="advant__item item-advant">
                  <div className="item-advant__title">
                    <img src="./assets/img/advant/01.svg" alt="Icon" />
                    Сверхдоходность
                  </div>
                  <div className="item-advant__text item-advant__text--text">
                    <p>
                      Трёхзначная потенциальная доходность при инвестициях в торговлю опытных трейдеров
                    </p>
                  </div>
                </div>
                <div data-fls-shadow="" className="advant__item item-advant">
                  <div className="item-advant__title">
                    <img src="./assets/img/advant/02.svg" alt="Icon" />
                    Гибкие сроки
                  </div>
                  <div className="item-advant__text item-advant__text--text">
                    <p>
                      Различные по срокам условия инвестирования средств от одного месяца до года и больше
                    </p>
                  </div>
                </div>
                <div data-fls-shadow="" className="advant__item item-advant">
                  <div className="item-advant__title">
                    <img src="./assets/img/advant/03.svg" alt="Icon" />
                    Быстрота
                  </div>
                  <div className="item-advant__text item-advant__text--text">
                    <p>Экономьте время на обучении, изучении аналитики и самостоятельной торговле</p>
                  </div>
                </div>
                <div data-fls-shadow="" className="advant__item item-advant">
                  <div className="item-advant__title">
                    <img src="./assets/img/advant/04.svg" alt="Icon" />
                    Прозрачность
                  </div>
                  <div className="item-advant__text item-advant__text--text">
                    <p>Следите за графиком торговли управляющего и проведенными операциями</p>
                  </div>
                </div>
                <div data-fls-shadow="" className="advant__item item-advant">
                  <div className="item-advant__title">
                    <img src="./assets/img/advant/05.svg" alt="Icon" />
                    Профессионализм
                  </div>
                  <div className="item-advant__text item-advant__text--text">
                    <p>Трейдинг осуществляется под полным контролем профессиональных управляющих</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="scheme">
          <div className="scheme__container">
            <div className="scheme__body">
              <div className="scheme__level scheme__level--center">
                <div className="scheme__element">
                  <span>Управляющий</span>
                  <div className="scheme__icon">
                    <img src="./assets/img/scheme/01.svg" alt="Icon" />
                  </div>
                  <span>Торговая платформа</span>
                </div>
              </div>
              <div className="scheme__level scheme__level--end">
                <picture className="scheme__arrow">
                  <source media="(max-width: 991.98px)" srcSet="./assets/img/scheme/arrow/min.svg" />
                  <img src="./assets/img/scheme/arrow/big.svg" alt="Arrow" />
                </picture>
                <div className="scheme__element">
                  <div className="scheme__icon">
                    <img src="./assets/img/scheme/02.svg" alt="Icon" />
                  </div>
                  <span>
                    Доверительное управление
                    <br />
                    торговлей
                  </span>
                </div>
                <picture className="scheme__arrow scheme__arrow--scale">
                  <source media="(max-width: 991.98px)" srcSet="./assets/img/scheme/arrow/min.svg" />
                  <img src="./assets/img/scheme/arrow/big.svg" alt="Arrow" />
                </picture>
              </div>
              <div className="scheme__level scheme__level--arrow">
                <img src="./assets/img/scheme/arrow/str.svg" alt="Arrow" />
              </div>
              <div className="scheme__level">
                <div className="scheme__element scheme__element--none">
                  <div className="scheme__icon">
                    <img src="./assets/img/scheme/03.svg" alt="Icon" />
                  </div>
                  <span>Инвестиционный счет</span>
                </div>
                <span className="scheme__span">Инвестиционный счет</span>
                <div className="scheme__element scheme__element--center">
                  <div className="scheme__icon">
                    <img src="./assets/img/scheme/03.svg" alt="Icon" />
                  </div>
                  <span>Инвестиционный счет</span>
                </div>
                <span className="scheme__span">Инвестиционный счет</span>
                <div className="scheme__element scheme__element--none">
                  <div className="scheme__icon">
                    <img src="./assets/img/scheme/03.svg" alt="Icon" />
                  </div>
                  <span>Инвестиционный счет</span>
                </div>
              </div>
              <div className="scheme__level">
                <div className="scheme__element scheme__element--none">
                  <div className="scheme__icon">
                    <img src="./assets/img/scheme/04.svg" alt="Icon" />
                  </div>
                </div>
                <div className="scheme__element scheme__element--center">
                  <div className="scheme__icon">
                    <img src="./assets/img/scheme/04.svg" alt="Icon" />
                  </div>
                </div>
                <div className="scheme__element scheme__element--none">
                  <div className="scheme__icon">
                    <img src="./assets/img/scheme/04.svg" alt="Icon" />
                  </div>
                </div>
              </div>
              <div className="scheme__level">
                <div className="scheme__element scheme__element--none">
                  <div className="scheme__icon">
                    <img src="./assets/img/scheme/05.svg" alt="Icon" />
                  </div>
                  <span>Инвестор</span>
                </div>
                <span className="scheme__span">Инвестор</span>
                <div className="scheme__element scheme__element--center">
                  <div className="scheme__icon">
                    <img src="./assets/img/scheme/05.svg" alt="Icon" />
                  </div>
                  <span>Инвестор</span>
                </div>
                <span className="scheme__span">Инвестор</span>
                <div className="scheme__element scheme__element--none">
                  <div className="scheme__icon">
                    <img src="./assets/img/scheme/05.svg" alt="Icon" />
                  </div>
                  <span>Инвестор</span>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="invest">
          <div className="invest__container invest__container--full">
            <div className="invest__body">
              <h3 className="invest__title invest__title--title-25">Вклады в инвестиционные ПАММ счета</h3>
              <div className="invest__content">
                <h4 className="invest__subtitle invest__subtitle--title-18">Сервис ПАММ счетов –</h4>
                <div className="invest__text">
                  <p>Это система процентного распределения прибыли между управляющим и инвестором</p>
                  <p>
                    Другими словами, ПАММ – счет где, управляющий имеет возможность использовать в торговле привлеченные средства инвесторов.
                  </p>
                  <p>
                    Заключается оферта – это договор, в котором регламентируются отношения между инвестором и управляющим. Прибыль получаемая в результате торговой деятельности управляющего, распределяется между инвесторами пропорционально вложенной сумме.
                  </p>
                </div>
                <a href="#" data-fls-button="" className="invest__button button">Попробовать</a>
              </div>
            </div>
          </div>
        </section>
        <section className="protect">
          <div className="protect__container protect__container--full">
            <div className="protect__body">
              <div className="protect__head">
                <h3 className="protect__title protect__title--title-25">Защита инвестиций</h3>
                <div className="protect__text protect__text--text">
                  <p>
                    Дилер биржевого рынка выступает в роли
                    <span>независимого гаранта</span>
                    выполнения обязательств как управляющего, так и инвестора. Отсюда вытекают следующие преимущества:
                  </p>
                </div>
              </div>
              <div className="protect__items items-protect">
                <div data-fls-shadow="" className="items-protect__item items-protect__item--text">
                  <p>Управляющий не может взять и уйти с деньгами инвесторов.</p>
                </div>
                <div data-fls-shadow="" className="items-protect__item items-protect__item--text">
                  <p>
                    Ваши средства и прибыль находятся на общем ПАММ-счёте, и только вы можете распоряжаться ими, так как они не передаются управляющему.
                  </p>
                </div>
                <div data-fls-shadow="" className="items-protect__item items-protect__item--text">
                  <p>
                    При консервативной торговле управляющий рискует только прибылью, а не капиталом инвесторов.
                  </p>
                </div>
              </div>
              <div className="protect__text protect__text--reverse protect__text--text">
                <p>
                  <span>Вывод прибыли.</span>
                  ПАММ-сервис позволяет настроить автоматический вывод прибыли по окончанию торгового интервала, что обеспечит Вам постоянный поток прибыли и ее сохранение на своем отдельном торговом счете.
                </p>
              </div>
            </div>
          </div>
        </section>
      </main>
      <footer data-fls-footer="" className="footer">
        <div className="footer__container footer__container--full">
          <div className="footer__body">
            <a href="/" className="footer__logo">
              <img src="/assets/img/logo.svg" alt="Logo" />
            </a>
            <div className="footer__actions">
              <a href="/login" data-fls-button="" className="footer__button button button--fw button--border-white">Вход</a>
              <a href="#" data-fls-button="" className="footer__button button button--fw">Регистрация</a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Home;